import request from '../request';

export const getTenant = () => {
  return request.get('tenant').then((res) => res);
};

export const getSettingsByCode = (code = '') => {
  return request.get(`tenant/settings/${code}`).then((res) => res);
};
export const getTenantSettings = (settingsCode = '', data = {}) =>
  request.get(`/tenant/settings/${settingsCode}`, data).then((res) => res);

export const getSecondaryNotificationEmail = () =>
  request.get('/tenant/secondary-notification-email').then((res) => res);

export const updateSecondaryNotificationEmail = (data = {}) =>
  request.put('/tenant/secondary-notification-email', data).then((res) => res);

export const getTripSettings = (tripid = '', settingsCode = '', data = {}) =>
  request
    .get(`/trip/${tripid}/settings/${settingsCode}`, data)
    .then((res) => res);

export const setTenantSettings = (settingCode = '', data = {}) =>
  request.post(`tenant/settings/${settingCode}`, data).then((res) => res);

export const setTripSettings = (tripid = '', settingCode = '', data = {}) =>
  request
    .post(`trip/${tripid}/settings/${settingCode}`, data)
    .then((res) => res);

export const getTripLogo = (tripid = '') =>
  request.get(`trip/${tripid}/logo`).then((res) => res);

export const uploadTripLogo = (tripid = '', file = {}) => {
  const formData = new FormData();
  formData.append('logo', file);

  return request.post(`trip/${tripid}/logo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const deleteTripLogo = (tripid = '') =>
  request.delete(`trip/${tripid}/logo`).then((res) => res);

export const getPassengerFields = () => {
  return request.get('tenant/passengerfields').then((res) => res);
};

export const createPassengerField = (data = {}) =>
  request.post('tenant/passengerfields', data).then((res) => res);

export const updatePassengerField = (data = {}, passengerfieldid = '') =>
  request
    .put(`tenant/passengerfields/${passengerfieldid}`, data)
    .then((res) => res);

export const deletePassengerField = (passengerfieldid = '') =>
  request
    .delete(`tenant/passengerfields/${passengerfieldid}`)
    .then((res) => res);

export const updatePassengerFieldSequence = (
  passengerfieldid = '',
  data = {}
) =>
  request
    .put(`tenant/passengerfields/${passengerfieldid}/sequence`, data)
    .then((res) => res);

export const updatePassengerFieldStatus = (passengerfieldid = '', data = {}) =>
  request
    .put(`tenant/passengerfields/${passengerfieldid}/status`, data)
    .then((res) => res);

export const getPassengerCollectionRounds = () =>
  request.get('tenant/passengercollectionrounds').then((res) => res);

export const createPassengerCollectionRound = (data = {}) =>
  request.post('tenant/passengercollectionrounds', data).then((res) => res);

export const updatePassengerCollectionRound = (
  passengercollectionroundid = '',
  data = {}
) =>
  request
    .put(`tenant/passengercollectionrounds/${passengercollectionroundid}`, data)
    .then((res) => res);

export const deletePassengerCollectionRound = (
  passengercollectionroundid = ''
) =>
  request
    .delete(`tenant/passengercollectionrounds/${passengercollectionroundid}`)
    .then((res) => res);

export const updatePassengerCollectionRoundSequence = (
  passengercollectionroundid = '',
  data = {}
) =>
  request
    .put(
      `tenant/passengercollectionrounds/${passengercollectionroundid}/sequence`,
      data
    )
    .then((res) => res);

export const addPassengerFieldToCollectionRound = (
  passengercollectionroundid = '',
  data = {}
) =>
  request
    .post(
      `tenant/passengercollectionrounds/${passengercollectionroundid}/fields`,
      data
    )
    .then((res) => res);

export const updatePassengerCollectionRoundFieldSequence = (
  passengercollectionroundid = '',
  passengerfieldid = '',
  data = {}
) =>
  request
    .put(
      `tenant/passengercollectionrounds/${passengercollectionroundid}/fields/${passengerfieldid}/sequence`,
      data
    )
    .then((res) => res);

export const updatePassengerCollectionRoundFieldAssignmentType = (
  passengercollectionroundid = '',
  passengerfieldid = '',
  data = {}
) =>
  request
    .put(
      `tenant/passengercollectionrounds/${passengercollectionroundid}/fields/${passengerfieldid}/assignmenttype`,
      data
    )
    .then((res) => res);

export const deletePassengerCollectionRoundField = (
  passengercollectionroundid = '',
  passengerfieldid = ''
) =>
  request
    .delete(
      `tenant/passengercollectionrounds/${passengercollectionroundid}/fields/${passengerfieldid}`
    )
    .then((res) => res);
